import apiVirtus from './apiVirtus';

// Regras de desconto/antecipação por CNPJ (backend-virtus).
//
// O endpoint aceita um param opcional `cobrador`; o portal (cliente logado, não
// coletor) não tem cobrador, então consultamos SÓ por CNPJ — nesse caso o backend
// filtra apenas pelo CNPJ e retorna todas as regras da empresa. Não há guard de
// autenticação nesses endpoints, mas mandamos o Bearer por consistência.
//
// Nem todo cliente tem regras: qualquer falha (rede, CNPJ inválido de 400, empresa
// sem regra) retorna [] para NUNCA quebrar o fluxo de pagamento atual.
const authHeaders = () => {
  const token = JSON.parse(sessionStorage.getItem('@portal-cliente/token'));
  return token ? { headers: { Authorization: 'Bearer ' + token } } : {};
};

export async function getDiscountRules(cnpj) {
  if (!cnpj) return [];
  try {
    const { data } = await apiVirtus.get(
      `/cobranca/charges/discount-rules/${cnpj}/list`,
      authHeaders(),
    );
    return Array.isArray(data) ? data : [];
  } catch {
    return [];
  }
}

export async function getAnticipationRules(cnpj) {
  if (!cnpj) return [];
  try {
    const { data } = await apiVirtus.get(
      `/cobranca/charges/anticipation-rules/${cnpj}/list`,
      authHeaders(),
    );
    return Array.isArray(data) ? data : [];
  } catch {
    return [];
  }
}
